export default __webpack_public_path__ + "static/media/approach.181d28d3.jpg";